const { default: axiosIns } = require('@/libs/axios')

const CatalogSchemas = {
  // GET - CatalogSchemaApiController
  async getCatalogSchemas(accountId) {
    return axiosIns.get(`/catalogs/schemas?accountId=${accountId}`).then(response => response.data)
  },
  async getCatalogSchema(catalogSchemaId, accountId) {
    return axiosIns.get(`/catalogs/schemas/${catalogSchemaId}?accountId=${accountId}`).then(response => response.data)
  },
  // POST - CatalogSchemaApiController
  async createCatalogSchema(model, accountId) {
    return axiosIns.post(`/catalogs/schemas?accountId=${accountId}`, model).then(response => response.data)
  },
  // PUT - CatalogSchemaApiController
  async updateCatalogSchema(model, accountId) {
    return axiosIns.put(`/catalogs/schemas/${model.id}?accountId=${accountId}`, model).then(response => response.data)
  },
  // DELETE - CatalogSchemaApiController
  async deleteCatalogSchema(catalogSchema, accountId) {
    return axiosIns.delete(`/catalogs/schemas/${catalogSchema.id}?accountId=${accountId}`).then(response => response.data)
  },
}

export default CatalogSchemas
